// Camera motion stays local to the viewer. Only publish after a pause, or when
// sharing explicitly flushes the latest position. Queues are isolated per store.
const pending = new WeakMap<object, () => void>();

export function flushViewerCameraUpdate(owner: object) {
  pending.get(owner)?.();
}

export function createCameraUpdateQueue<T>(owner: object, publish: (value: T) => void, delay = 200) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let latest: { value: T } | undefined;
  const cancel = () => {
    clearTimeout(timer);
    timer = undefined;
    latest = undefined;
    if (pending.get(owner) === flush) pending.delete(owner);
  };
  const flush = () => {
    const value = latest;
    cancel();
    if (value) publish(value.value);
  };
  return {
    push(value: T) {
      clearTimeout(timer);
      latest = { value };
      pending.set(owner, flush);
      timer = setTimeout(flush, delay);
    },
    cancel,
  };
}
